import angular from 'angular';
import { get, clone, isEmpty } from 'lodash';

const module = angular.module('whyline.modals.external-services-settings', []);

const ExternalServicesSettingsModalController = function(
	$uibModalInstance,
	organization,
) {
	'ngInject';

	this.organizationConfiguration = {};

	const init = () => {
		this.organizationConfiguration = get(organization, 'configuration', {});
	};

	this.cancel = () => {
		$uibModalInstance.close('cancel');
	};

	init();
}

module.exports = module.controller('ExternalServicesSettingsModalController', ExternalServicesSettingsModalController);
